import { useState } from 'react'
import { startOfISOWeek, endOfISOWeek } from 'date-fns'
import moment from 'moment'

export const useCalendar = (initialDate?: string) => {
  const parsedInitialDate = initialDate
    ? moment(initialDate, 'DD-MM-YYYY').toDate()
    : new Date()

  const [date, setDate] = useState<Date>(parsedInitialDate)

  const onDateClick = (date: Date) => {
    setDate(date)
  }

  const onNavigate = (date: Date) => {
    setDate(date)
  }

  const weekStart = startOfISOWeek(date)
  const weekEnd = endOfISOWeek(date)

  return {
    date,
    onDateClick,
    onNavigate,
    weekStart,
    weekEnd,
  }
}
